import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use(LanguageDetector)
// pass the i18n instance to react-i18next.
.use(initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    debug: false,
    lng: 'ru', // default language - перекрывает записанное детектором языка значение
    fallbackLng: 'ru', // language to use if translations in user language are not available
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        ru: {
            translation: {
                about: {
                    title: 'О программе',
                    about: 'Каталог экспонентов.<br/>Разработан <a href="https://alxgrn.ru" target="_blank">Александром Федоровым</a> по заказу <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>.',
                },
                common: {
                    catalog: 'Каталог участников',
                    loading: 'Загрузка...',
                    more: 'Больше',
                    less: 'Меньше',
                },
                error: {
                    error: 'Ошибка',
                    noerror: 'Готово',
                    unknown: 'Ошибка: Неизвестная ошибка',
                    api0: 'Ошибка: Нет ошибок',
                    api1: 'Ошибка: Недостаточно прав',
                    api2: 'Ошибка: Недостаточно данных',
                    api3: 'Ошибка: Некорректные данные',
                    api4: 'Ошибка: Объект уже существует',
                    api5: 'Ошибка: Объект не найден',
                    api6: 'Ошибка: Ошибка базы данных',
                    api7: 'Ошибка: Ошибка сервера',
                    http0: 'Ошибка: Ошибка сети',
                    http400: 'Ошибка: Неправильный запрос',
                    http401: 'Ошибка: Требуется авторизация',
                    http403: 'Ошибка: В доступе отказано',
                    http404: 'Ошибка: Объект не найден',
                    http413: 'Ошибка: Размер запроса слишком велик',
                    http500: 'Ошибка: Ошибка сервера',
                },
                mode: {
                    exhibitors: 'По участникам',
                    activities: 'По мероприятиям',
                },
                filter: {
                    title: 'Фильтр',
                    settings: 'Фильтр',
                    geography: 'География',
                    clear: 'Очистить фильтр',
                    date: 'Мероприятия на стенде',
                },
                pager: {
                    prev: 'Пред',
                    next: 'След',
                    page: 'Страница',
                    of: 'из',
                },
                events: {
                    title: 'Наши выставки',
                },
                exhibitor: {
                    title: 'Экспонент',
                    stand: 'Стенд',
                    brand: 'Представляемые нами бренды',
                    about: 'О компании',
                    descr: 'На нашем стенде',
                    contacts: 'Контакты',
                    links: 'Социальные сети',
                    categories: 'Категории',
                    activities: 'Мероприятия на стенде',
                    back: 'Все участники',
                    featured: 'Обратите внимание',
                    files: 'Файлы',
                    download: 'Скачать',
                },
                activity: {
                    host: 'Организатор',
                    date: 'Дата и время',
                    descr: 'Описание',
                    speaker: 'Спикер',
                    other: 'Другие мероприятия на стенде организатора',
                    back: 'Все мероприятия',
                },
                activities: {
                    found: 'По запросу «{{query}}» найдено мероприятий: {{count}}',
                    notfound: 'По запросу «{{query}}» мероприятий не найдено',
                    noquery: 'Найдено мероприятий: {{count}}',
                    noqueryfound: 'Мероприятий не найдено',
                },
                exhibitors: {
                    found: 'По запросу «{{query}}» среди {{where}} экспонентов найдено участников: {{count}}',
                    notfound: 'По запросу «{{query}}» среди {{where}} экспонентов участников не найдено',
                    noquery: 'Найдено участников: {{count}}',
                    noqueryfound: 'По заданному запросу участников не найдено',
                    countries: 'стран',
                    cities: 'городов',
                    names: 'имён',
                    brands: 'брендов',
                    stands: 'стендов',
                    texts: 'описаний',
                    everywhere: 'полного описания',
                    index: '',
                },
                favorites: {
                    title: 'Избранное',
                    infav: 'В избранном',
                    nofav: 'Добавить в избранное',
                    activity_infav: 'Мероприятие в избранном',
                    activity_nofav: 'Добавить мероприятие в избранное',
                    exhibitor_infav: 'Участник в избранном',
                    exhibitor_nofav: 'Добавить участника в избранное',
                    activities: 'Мероприятия',
                    exhibitors: 'Участники',
                    noactivities: 'Для данной выставки вы не выбрали ни одного мероприятия',
                    noexhibitors: 'Для данной выставки вы не выбрали ни одного участника',
                    export: 'Экспорт в PDF',
                },
                search: {
                    placeholder: 'Поиск по ключевым словам',
                    where: 'Показать результаты поиска',
                    names: 'в именах',
                    countries: 'в странах',
                    cities: 'в городах',
                    brands: 'в брендах',
                    stands: 'в стендах',
                    texts: 'в описаниях',
                    everywhere: 'везде',
                },
            },
        },
        en: {
            translation: {
                about: {
                    title: 'About',
                    about: 'Exhibitor catalog.<br/>Developed by <a href="https://alxgrn.ru" target="_blank">Alexander Fedorov</a> commissioned by <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>.',
                },
                common: {
                    catalog: 'Exhibitor catalog',
                    loading: 'Loading...',
                    more: 'More',
                    less: 'Less',
                },
                error: {
                    error: 'Error',
                    noerror: 'Ok',
                    unknown: 'Error: Unknown Error',
                    api0: 'Error: Ok',
                    api1: 'Error: Access Denied',
                    api2: 'Error: Data Missing',
                    api3: 'Error: Bad Data',
                    api4: 'Error: Object Exists',
                    api5: 'Error: Not Found',
                    api6: 'Error: Database Error',
                    api7: 'Error: Server Error',
                    http0: 'Error: Network Error',
                    http400: 'Error: Bad Request',
                    http401: 'Error: Unauthorized',
                    http403: 'Error: Forbidden',
                    http404: 'Error: Not Found',
                    http413: 'Error: Request Entity Too Large',
                    http500: 'Error: Server Error',
                },
                mode: {
                    exhibitors: 'By exhibitors',
                    activities: 'By activities',
                },
                filter: {
                    title: 'Filter',
                    settings: 'Filter',
                    geography: 'Geography',
                    clear: 'Clear filter',
                    date: 'Activity at the stand',
                },
                pager: {
                    prev: 'Prev',
                    next: 'Next',
                    page: 'Page',
                    of: 'of',
                },
                events: {
                    title: 'Our events',
                },
                exhibitor: {
                    title: 'Exhibitor',
                    stand: 'Stand',
                    brand: 'Brands we represent',
                    about: 'About the company',
                    descr: 'Activities at the stand',
                    contacts: 'Contacts',
                    links: 'Social networks',
                    categories: 'Categories',
                    activities: 'Activities at the stand',
                    back: 'All exhibitors',
                    featured: 'Featured company',
                    files: 'Files',
                    download: 'Download',
                 },
                 activity: {
                    host: 'Organizer',
                    date: 'Date and time',
                    descr: 'Description',
                    speaker: 'Speaker',
                    other: 'Other activities at the organizer\'s booth',
                    back: 'All activities',
                },
                activities: {
                    found: 'The query «{{query}}» found {{count}} activities',
                    notfound: 'No activities were found for the query «{{query}}»',
                    noquery: 'Found activities: {{count}}',
                    noqueryfound: 'No activities found',
                },
                exhibitors: {
                    found: '{{count}} companies were found for the query «{{query}}» among exhibitor {{where}}',
                    notfound: 'No companies were found for the query «{{query}}» among exhibitor {{where}}',
                    noquery: 'Showing {{count}} exhibitors',
                    noqueryfound: 'No exhibitors found for the given query',
                    countries: 'countries',
                    cities: 'cities',
                    names: 'names',
                    brands: 'brands',
                    stands: 'stands',
                    texts: 'descriptions',
                    everywhere: 'full descriptions',
                    index: 'profiles',
                },
                favorites: {
                    title: 'Favorites',
                    infav: 'In favorites',
                    nofav: 'Add to favorites',
                    activity_infav: 'Activity in favorites',
                    activity_nofav: 'Add activity to favorites',
                    exhibitor_infav: 'Exhibitor in favorites',
                    exhibitor_nofav: 'Add exhibitor to favorites', 
                    activities: 'Activities',
                    exhibitors: 'Exhibitors',
                    noactivities: 'You have not selected any activities for this event',
                    noexhibitors: 'You have not selected any exhibitors for this event',
                    export: 'Export to PDF',
                },
                search: {
                    placeholder: 'Keyword search',
                    where: 'Show search results',
                    names: 'in names',
                    countries: 'in countries',
                    cities: 'in cities',
                    brands: 'in brands',
                    stands: 'in stands',
                    texts: 'in descriptions',
                    everywhere: 'everywhere',
                },
            },
        },
    },
});

export default i18n;
